export const en = {
    translation: {
        errorCodes: {
            PARSE_ERROR: 'Failed to parse',
            BAD_REQUEST: 'Invalid request',
            INTERNAL_SERVER_ERROR: 'Unexpected server error',
            NOT_IMPLEMENTED: 'Not implemented',
            UNAUTHORIZED: 'No valid administrator',
            FORBIDDEN: 'Access forbidden',
            NOT_FOUND: 'Not found',
            METHOD_NOT_SUPPORTED: 'Method is not supported',
            TIMEOUT: 'A timeout has occurred',
            CONFLICT: 'A conflict has occurred',
            PRECONDITION_FAILED: 'A pre-condition has failed',
            PAYLOAD_TOO_LARGE: 'The payload is too big',
            UNPROCESSABLE_CONTENT: 'Unable to process the data',
            TOO_MANY_REQUESTS: 'Too many requests',
            CLIENT_CLOSED_REQUEST: 'Client has closed the request',
        },
        actions: {
            ok: 'Ok',
            yes: 'Yes',
            no: 'No',
            help: 'Help',
            back: 'Back',
            next: 'Next',
            create: 'Create',
            createNamed: 'Create\xa0{{name}}',
            save: 'Save',
            saveChanges: 'Save\xa0changes',
            saveDraft: 'Save\xa0draft',
            cancel: 'Cancel',
            close: 'Close',
            edit: 'Edit',
            editSettings: 'Edit\xa0settings',
            delete: 'Delete',
            remove: 'Remove',
            discardChanges: 'Discard changes',
            assign: 'Assign',
            print: 'Print',
            download: 'Download',
            share: 'Share',
            send: 'Send',
            import: 'Import',
            export: 'Export',
            archive: 'Archive',
            unarchive: 'Unarchive',
            preview: 'Preview',
            view: 'View',
            clear: 'Clear',
            apply: 'Apply',
            submit: 'Submit',
            copyToClipboard: 'Copy to clipboard',
            useUserTimezone: 'Use my timezone',
            applyFilter: 'Apply filter',
            clearFilter: 'Clear filter',
            loadMore: 'Load more',
            more: 'More',
        },
        misc: {
            sortedBy: 'sorted by',
            sortAscending: 'Sort ascending',
            sortDescending: 'Sort descending',
            today: 'Today',
            calendarWeek: 'CW',
            copiedToClipboard: 'Copied to clipboard',
            tagsEdit: 'Type to add tags',
            tagsReadOnly: 'No tags available',
            required: 'Required',
            optional: 'Optional',
        },
        components: {
            form: {
                submitError: 'Something went wrong during submitting please try again',
                submitSuccess: 'Changes successfully saved',
                deleteError: 'Something went wrong during deletion please try again',
                deleteSuccess: 'Successfully deleted',
            },
            markdownToolbar: {
                bold: 'Bold',
                italic: 'Italic',
                strikeThrough: 'Strike-Through',
                highlight: 'Highlight',
                heading: 'Heading {{level}}',
                unorderedList: 'Bullets',
                orderedList: 'List',
                divider: 'Divider',
                link: 'Link',
                image: 'Image',
                file: 'File',
                quote: 'Quote',
            },
            useUpload: {
                fileTooLarge: {
                    title: 'File too large',
                    message: 'The given file is too large for uploading',
                },
                uploadError: {
                    title: 'Upload failed',
                    message: 'Some error ocurred during uploading, please try again',
                },
                progress: 'Uploading file ({{progress}}%)...',
            },
        },
    },
}
